export default {
  headerTasks: 'Wartungsaufgaben',
  headerAttachments: 'Anhänge',
  noAssetBlobs: 'Anlage {asset} hat keine Dokumentation.',
};
